export interface ToastStateI {
  message: string;
  type: string;
  show?: boolean;
  timeout?: number;
}

export const state: ToastStateI = {
  message: '',
  type: '',
  show: false,
  timeout: 3000,
};
